import React from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import FavoriteIcon from "@mui/icons-material/Favorite";

const InfoSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",

  width: "100%",
  height: "100%", // ← importante

  borderRadius: 16,
  boxShadow: theme.shadows[6],
  background: "#fff",
}));

const Image = styled("img")({
  width: "100%",
  aspectRatio: "16 / 9",
  objectFit: "cover",
  borderRadius: 12,
  marginBottom: 20,
  boxShadow: "0px 4px 12px rgba(0,0,0,.2)",
});

const DestinoDetails = ({
  destino,
  likes,
  liked,
  handleLike,
  isLiking,
}) => {
  const {
    nombre,
    direccion,
    ciudad,
    descripcion,
    foto,
  } = destino;

  return (
    <InfoSection>

      {foto && (
        <Image
          src={foto}
          alt={nombre}
        />
      )}

      <Box
        display="flex"
        alignItems="center"
        mb={2}
      >
        <Tooltip
          title={
            liked
              ? "Quitar me gusta"
              : "Dar me gusta"
          }
        >
          <span>
            <IconButton
              onClick={handleLike}
              color={liked ? "error" : "default"}
              disabled={isLiking}
            >
              <FavoriteIcon />
            </IconButton>
          </span>
        </Tooltip>

        <Typography
          variant="body2"
          ml={1}
        >
          {likes} Me gusta
        </Typography>
      </Box>

      <Typography
        variant="h5"
        fontWeight="bold"
        color="primary"
        gutterBottom
      >
        {nombre}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          lineHeight: 1.8,
          mb: 3,
          flexGrow: 1, // ← llena el espacio restante
        }}
      >
        {descripcion}
      </Typography>

      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{ mb: 1 }}
      >
        <strong>Dirección:</strong> {direccion}
      </Typography>

      <Typography
        variant="subtitle2"
        color="text.secondary"
      >
        <strong>Ciudad:</strong> {ciudad}
      </Typography>

    </InfoSection>
  );
};

export default DestinoDetails;